/* eslint-disable no-useless-escape */
const START_PAGES = {
    ACTIVATION_PAGE: 4,
    CONFIRMATION_PAGE: 3,
    CUSTOMER_PAGE: 0,
    DEVICE_PAGE: 1,
    SUBSCRIPTION_PAGE: 2
}

const MOCK_TEST_DATA = false
const TEST_DISABLED_ACTIVATION_ON_BACKEND = false
const TEST_START_PAGE = START_PAGES.CUSTOMER_PAGE
const TEST_DATA = {
    step1: {
        activationCode: 'SWSYB A3W72',
        customerNumber: '960015'
    },
    step2: {
        dak: '6D58-6U6B-7K',
        deviceSerialNumber: 'MN5017F00416'
    }
}

const TEST_DATA_QA = {
    step1: {
        activationCode: '8DESDMMMG6',
        customerNumber: '00006'
    },
    step2: {
        deviceSerialNumber: 'MN5017F00413'
    }
}

const VALIDATORS_CONFIG = {
    step1: {
        activationCode: {
            enabled: {
                correctness: true,
                maxLength: true,
                minLength: true
            },
            regex: new RegExp(/[A-z0-9]{5}(\s)?[A-z0-9]{5}$/)
        },
        customerNumber: {
            enabled: {
                correctness: true,
                maxLength: true,
                minLength: true
            }
        }
    },
    step2: {
        dakFormat: {
            enabled: true,
            tenCharsRegex: new RegExp(/[A-z0-9]{4}(\s|[\-])?[A-z0-9]{4}(\s|[\-])?[A-z0-9]{2}$/),
            twelveCharsRegex: new RegExp(/[A-z0-9]{4}(\s|[\-])?[A-z0-9]{4}(\s|[\-])?[A-z0-9]{4}$/)
        },
        serialNo: {
            enabled: {
                correctness: true,
                equality: true
            },
            regex: new RegExp(/[A-z]{2}\d{4}[A-z]{1}\d{5}/)
        }
    },
    step3: {
        generationChoose: { enabled: true },
        licensePlate: { enabled: true },
        link340: {
            enabled: true,
            prefix: ['NH', 'NI', 'NQ', 'NS', 'MX']
        }
    }
}

const LOCALE = {
    csCZ: 'cs-CZ',
    daDK: 'da-DK',
    deAT: 'de-AT',
    deCH: 'de-CH',
    deDE: 'de-DE',
    enAE: 'en-AE',
    enAU: 'en-AU',
    enGB: 'en-GB',
    enIE: 'en-IE',
    enNZ: 'en-NZ',
    enUS: 'en-US',
    enZA: 'en-ZA',
    esCL: 'es-CL',
    esCO: 'es-CO',
    esES: 'es-ES',
    esMX: 'es-MX',
    frBE: 'fr-BE',
    frCH: 'fr-CH',
    frFR: 'fr-FR',
    itCH: 'it-CH',
    itIT: 'it-IT',
    nlBE: 'nl-BE',
    nlNL: 'nl-NL',
    plPL: 'pl-PL',
    ptPT: 'pt-PT',
    svSE: 'sv-SE'
}

const AVAILABLE_LANGUAGES = [
    {
        label: 'Czech',
        locale: LOCALE.csCZ
    },
    {
        label: 'Danish',
        locale: LOCALE.daDK
    },
    {
        label: 'German',
        locale: LOCALE.deDE
    },
    {
        label: 'English (UK)',
        locale: LOCALE.enGB
    },
    {
        label: 'English (US)',
        locale: LOCALE.enUS
    },
    {
        label: 'Spanish',
        locale: LOCALE.esES
    },
    {
        label: 'French',
        locale: LOCALE.frFR
    },
    {
        label: 'Italian',
        locale: LOCALE.itIT
    },
    {
        label: 'Dutch',
        locale: LOCALE.nlNL
    },
    {
        label: 'Polish',
        locale: LOCALE.plPL
    },
    {
        label: 'Portuguese',
        locale: LOCALE.ptPT
    },
    {
        label: 'Swedish',
        locale: LOCALE.svSE
    }
]

const FALLBACK_LOCALE = 'en-GB'

const LOCALES_MAPPING = {
    [LOCALE.deAT]: {
        fallbackLocale: LOCALE.deDE
    },
    [LOCALE.deCH]: {
        fallbackLocale: LOCALE.deDE
    },
    [LOCALE.enAU]: {
        fallbackLocale: LOCALE.enGB
    },
    [LOCALE.enNZ]: {
        fallbackLocale: LOCALE.enGB
    },
    [LOCALE.enZA]: {
        fallbackLocale: LOCALE.enGB
    },
    [LOCALE.enIE]: {
        fallbackLocale: LOCALE.enGB
    },
    [LOCALE.enAE]: {
        fallbackLocale: LOCALE.enGB
    },
    [LOCALE.esMX]: {
        fallbackLocale: LOCALE.esES
    },
    [LOCALE.esCL]: {
        fallbackLocale: LOCALE.esES
    },
    [LOCALE.esCO]: {
        fallbackLocale: LOCALE.esES
    },
    [LOCALE.frCH]: {
        fallbackLocale: LOCALE.frFR
    },
    [LOCALE.frBE]: {
        fallbackLocale: LOCALE.frFR
    },
    [LOCALE.itCH]: {
        fallbackLocale: LOCALE.itIT
    },
    [LOCALE.nlBE]: {
        fallbackLocale: LOCALE.nlNL
    }
}

export {
    MOCK_TEST_DATA,
    TEST_DATA,
    TEST_DATA_QA,
    TEST_DISABLED_ACTIVATION_ON_BACKEND,
    TEST_START_PAGE,
    VALIDATORS_CONFIG,
    AVAILABLE_LANGUAGES,
    FALLBACK_LOCALE,
    LOCALES_MAPPING
}
